export default __webpack_public_path__ + "static/media/Zawgyi-One.5eb3ace8.ttf";